var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-label"},[_c('v-chip',{attrs:{"small":"","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.num)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }